import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SiteFooter from './SiteFooter';
import SiteHeader from './SiteHeader';
import '../assets/styles/Site.scss';

const THEME_KEY = 'theme_mode';

export type ThemeMode = 'dark' | 'light';

function getInitialMode(): ThemeMode {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === 'dark' || saved === 'light') return saved;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

function Layout() {
  const [mode, setMode] = useState<ThemeMode>(getInitialMode);

  const toggleMode = () => {
    setMode((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem(THEME_KEY, next);
      return next;
    });
  };

  return (
    <div className={`ft-root theme-${mode}`}>
      <SiteHeader mode={mode} onToggleMode={toggleMode} />
      <Outlet />
      <SiteFooter />
    </div>
  );
}

export default Layout;
